import _ from 'underscore';

export const getImageBulkEditODataService = ({
  odata, oDataConfig, aid, cid, // logger,
}) => {
  //
  const getImageCroppingTaskStatus = (imageId) => {
    let url;
    if (imageId) {
      url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images(${imageId})/Default.ImageCroppingTaskStatus`;
    } else {
      url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.ImageCroppingTaskStatus`;
    }
    return odata.get(url, oDataConfig);
  };

  // crop an image and related placements
  const cropImage = ({ imageId, cropSettings = null, placementSettings = [] }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images(${imageId})/Default.Crop`;

    const cropData = {
      CropSettingOnOriginal: cropSettings,
      PlacementSettings: placementSettings,
    };

    const requestBody = _.extend({
      data: cropData,
    }, oDataConfig);

    return odata.post(url, requestBody);
  };

  const generateImageWithSmartEffect = ({ options }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Default.MediaGeneration`;
    const requestBody = _.extend({
      data: options,
    }, oDataConfig);

    return odata.post(url, requestBody);
  };

  return {
    getImageCroppingTaskStatus,
    cropImage,
    generateImageWithSmartEffect,
  };
};
